/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sources_2_LabelInputs */

const en_gc_search_guides_gridcraft_vs_excel_sources_2_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sources_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft: Excel editions and plans`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sources_2_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sources_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft：Excel 版本与方案`)
};

/**
* | output |
* | --- |
* | "Microsoft: Excel editions and plans" |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sources_2_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sources_2_label = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sources_2_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sources_2_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sources_2_label(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sources_2_label(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sources_2_label as "gc.search_guides.gridcraft_vs_excel.sources.2.label" }